import { render, staticRenderFns } from "./BaseMenu.vue?vue&type=template&id=ec113a28&scoped=true"
import script from "./BaseMenu.vue?vue&type=script&lang=js"
export * from "./BaseMenu.vue?vue&type=script&lang=js"
import style0 from "./BaseMenu.vue?vue&type=style&index=0&id=ec113a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec113a28",
  null
  
)

export default component.exports